export const getCurrentUser = () => {
  let user = null;
  try {
    user =
      localStorage.getItem('kde_user') != null
        ? JSON.parse(localStorage.getItem('kde_user'))
        : null;
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js  : getCurrentUser -> error', error);
    user = null;
  }
  return user;
};

export const setCurrentUser = (user) => {
  try {
    if (user) {
      localStorage.setItem('kde_user', JSON.stringify(user));
    } else {
      localStorage.removeItem('kde_user');
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentUser -> error', error);
  }
};

export const setMode = (mode) => {
  try {
    localStorage.setItem('viewMode', mode)
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setMode -> error', error);
  }
}

export const getMode = () => {
  let mode = 'darkMode'
  try {
    mode = localStorage.getItem('viewMode')
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : getMode -> error', error);
  }

  return mode
}

/**
 * Draw the keypoints on the video.
 * @param ctx 2D rendering context.
 * @param data A face data to render.
 * @param boundingBox Whether or not to display the bounding box.
 * @param showKeypoints Whether or not to display the keypoints.
 */
function drawPath(ctx, points, closePath) {
  const region = new Path2D();
  region.moveTo(points[0][0], points[0][1]);
  for (let i = 1; i < points.length; i++) {
    const point = points[i];
    region.lineTo(point[0], point[1]);
  }

  if (closePath) {
    region.closePath();
  }
  ctx.stroke(region);
}

export function canvasDrawResults(ctx, data, boundingBox, showKeypoints) {
  const keypoints =
    data.keypoints.map((keypoint) => [keypoint.x, keypoint.y]);

  if (boundingBox) {
    ctx.strokeStyle = '#32EEDB';
    ctx.lineWidth = 3;

    const box = data.box;
    drawPath(
      ctx,
      [
        [box.xMin, box.yMin], [box.xMax, box.yMin], [box.xMax, box.yMax],
        [box.xMin, box.yMax]
      ],
      true);
  }

  if (showKeypoints) {
    ctx.fillStyle = '#157AB3';

    for (let i = 0; i < 6; i++) {
      const x = keypoints[i][0];
      const y = keypoints[i][1];

      ctx.beginPath();
      ctx.arc(x, y, 3 /* radius */, 0, 2 * Math.PI);
      ctx.fill();
    }
  }
}